import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { SharedModule } from '../shared.module';
import { BankSectionFormComponent } from './bank-section-form/bank-section-form.component';
import { ContactSectionFormComponent } from './contact-section-form/contact-section-form.component';
import { EmploymentSectionFormComponent } from './employment-section-form/employment-section-form.component';
import { IdentitySectionFormComponent } from './identity-section-form/identity-section-form.component';
import { IncomeTransactionSectionFormComponent } from './income-transaction-section-form/income-transaction-section-form.component';

// INC-289 Phase 1: the identity/contact/bank field sub-components are the ONE
// place these fields, validators, and error messages are defined — both the
// standalone settings pages (profile-details, payment-methods) and the
// Phase-2 review-attest edit sheet embed them rather than re-declaring the
// fields. Relies on being imported by a module that also imports CoreModule
// (as SettingsModule already does) to resolve CountriesService /
// SettingService — kept out of this module's own imports to avoid pulling in
// CoreModule's large, unrelated declaration set.
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDatepickerModule,
    DigitOnlyModule,
    TranslateModule,
    SharedModule,
  ],
  declarations: [
    IdentitySectionFormComponent,
    ContactSectionFormComponent,
    EmploymentSectionFormComponent,
    IncomeTransactionSectionFormComponent,
    BankSectionFormComponent,
  ],
  exports: [
    IdentitySectionFormComponent,
    ContactSectionFormComponent,
    EmploymentSectionFormComponent,
    IncomeTransactionSectionFormComponent,
    BankSectionFormComponent,
  ],
})
export class ProfileSectionFormsModule {}
